

        <h1>오시는 길</h1>
        <div class="location">
            <img src="/assets/images/map.png" data-aos="fade-right">
            <div class="address">
                <ul>
                    <li>경기도 성남시 복정로 115 대림빌딩 3층</li>
                    <li><a href="https://goo.gl/maps/uNi3DjQ35hJgn8cT9"
                        target="blank"><img src="/assets/images/map-google.png"></a></li>
                    <li><a href="http://naver.me/GomNNKZr" target="blank"><img
                            src="/assets/images/map-naver.png"></a></li>
                </ul>
            </div>
            <div class="tel">
                <i class="xi-call">&nbsp;031-698-4115</i>
                <p></p>
                <i class="xi-fax">&nbsp;031-698-4118</i>
                <p></p>
            </div>
        </div>
